const ACCOUNT_AMP_BASE =
  process.env.REACT_APP_AccountAMP_Url || 'https://momentumampapi-stage.insurancegig.com';

const PLR_BASE = `${ACCOUNT_AMP_BASE}/api/PersonalLineRating`;

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('authToken') ?? '';
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

export interface PersonalLineRatingStatus {
  isEnabled: boolean;
  isMcpConfigured: boolean;
}

export interface EnablePersonalLineRatingResult {
  success: boolean;
  message: string;
  code?: string;
}

export async function getPersonalLineRatingStatus(): Promise<PersonalLineRatingStatus> {
  const res = await fetch(`${PLR_BASE}/status`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`PLR status check failed: ${res.status}`);
  return res.json();
}

export async function enablePersonalLineRating(
  rateJwt: string,
): Promise<EnablePersonalLineRatingResult> {
  const res = await fetch(`${PLR_BASE}/enable`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ rateJwt }),
  });
  if (!res.ok) throw new Error(`PLR enable failed: ${res.status}`);
  return res.json();
}
